import { Box, Loader, LoaderNew, ModalDialog, useWindowDimensions } from '@jfs/ui-new'
import { useRoute } from '@react-navigation/native'
import { createStackNavigator } from '@react-navigation/stack'
import * as React from 'react'
import { FC, lazy, Suspense, useState } from 'react'
import { ViewStyle } from 'react-native'
import { LinearGradientContainer } from '../../comps/LinearGradient'
import { ModBox } from '../../comps/ModifiedBox/ModifiedBox'
import { staticStrings } from '../../data/static/strings'
import { RootStore, useStores } from '../../data/store'
import { Routes } from '../../nav/routes'
import { APIEndPoints } from '../../network/APIEndpoints'
import { CampaignDetails } from '../../screens/CampaignDetails'
import { Colors, isMobile, showSearchView } from '../../util/util'
// import Webpage from '../Webpage'
import Footer from './Footer'
import Header from './Header'
// import InActivity from './Inactivity'
import { useIsLargeScreen } from '@jfs/utils'
import { RenderChatbotAwarenessWeb } from '../../screens/Home/RenderChatbotAwareness'
import PayoutHistory from '../../screens/PayoutHistory'
import Payouts from '../../screens/Payouts'
import PayoutsLink from '../../screens/PayoutsLink'
import AddNewUser from '../../screens/Settings/UserManagementTab/AddNewUser'
import EditUserRole from '../../screens/Settings/UserManagementTab/EditUser'
import SupersetEmbedded from '../../screens/supersetEmbedded'
import { navigationRef } from '../RootNav'
import { NavBarNew } from './NavBarNew'
import styles from './styles'

const Stack = createStackNavigator()
const ContactUs = lazy(() => import('../../screens/ContactUs/'))
const Transactions = lazy(() => import('../../screens/TransactionNew/'))
const BulkRefund = lazy(() => import('../../screens/BulkRefund/'))
const Profile = lazy(() => import('../../screens/ProfileWeb/'))
const Downloads = lazy(() => import('../../screens/Downloads/'))
const Dashboard = lazy(() => import('../../screens/Home/'))
const InitiateRefund = lazy(() => import('../../screens/InitiateRefund/'))
const Insights = lazy(() => import('../../screens/Insights/'))
const Campaigns = lazy(() => import('../../screens/Campaigns/'))
const CreateCampaign = lazy(() => import('../../screens/CreateCampaign/'))
const PaymentLinks = lazy(() => import('../../screens/PaymentLinks/'))
const CreatePaymentLink = lazy(() => import('../../screens/PaymentLinks/CreatePaymentLink/'))
const RefundsNew = lazy(() => import('../../screens/RefundsNew/'))
const Settings = lazy(() => import('../../screens/Settings/'))
// const AddNewUser = lazy(() => import('../../screens/Settings/UserManagementTab/AddNewUser/'))
// const EditUserRole = lazy(() => import('../../screens/Settings/UserManagementTab/EditUser/'))
const SettlementsScreen = lazy(() => import('../../screens/Settlements/'))
const Subscriptions = lazy(() => import('../../screens/Subscriptions/'))
const UpiQRCode = lazy(() => import('../../screens/UpiQRCode/'))
const TransactionDetails = lazy(() => import('../../screens/TransactionDetails/'))
const SettlementsReporting = lazy(() => import('../../screens/Settlements/Reporting'))
const AddNewSettlementReport = lazy(() => import('../../screens/Settlements/Reporting/AddNewSettlementReport'))
const NotAvailableConfiguration = lazy(() => import('../../screens/Settlements/Reporting/NotAvailableConfiguration'))
const Vault = lazy(() => import('../../screens/Vault/'))
const BeneficiaryOnboarding = lazy(() => import('../../screens/BeneficiaryOnboarding'))
const HelpAndSupportMobileWeb = lazy(() => import('../../screens/Support/web/'))

export const renderAlertModal = (): React.ReactElement => {
  return (
    <Box {...styles.alert}>
      <Loader type="large" />
    </Box>
  )
}

export const getPath = (location: any): string => {
  return location?.pathname?.substring(1) ?? Routes.TRANSACTIONS
}

const { REACT_APP_ENDPOINT = '' } = (window?._env_ ?? {})

const NewDashboard: FC = ({ route }) => {
  const params: any = route?.params
  const permissionLoader: any = route?.params?.permissionLoader
  const location = useRoute().name
  const navigation = navigationRef

  const [showTransactionDetails, setTransactionDetails] = useState(false)
  const [txnId, setTxnId] = useState('')
  const [trxDate, setTrxDate] = useState('')
  const width = useWindowDimensions()

  const {
    updateSelectedTxn,
    setSearchString,
    setSearchResultVisibility,
    disableBulkRefund,
    isSmid,
    notAllowedUserPermission,
    setDownloadReportType,
    canViewTransactionDetails,
    canCreatePaymentLink,
    mid,
    payoutsEnabled,
    supersetDashboards,
    hasSupersetPermission,
    shouldEnableSettingForSuperset,
    showChatbotAwareness,
    setShowChatbotAwareness,
  } = useStores((root) => ({
    updateSelectedTxn: root?.transactions?.updateSelectedTxn,
    setSearchString: root?.settings.metaData?.setSearchString,
    setSearchResultVisibility: root?.settings.metaData?.setSearchResultVisibility,
    disableBulkRefund: root?.settings?.metaData?.disableBulkRefund,
    mid: root?.user?.selectedMid,
    notAllowedUserPermission: root?.userManagement?.notAllowedUserPermission,
    setDownloadReportType: root?.settings?.metaData?.setDownloadReportType,
    canViewTransactionDetails: root?.userManagement?.canViewTransactionDetails(),
    canCreatePaymentLink: root?.userManagement?.canCreatePaymentLink(),
    selectedMercName: root?.settings.metaData.selectedMercName,
    selectedMerchantStatus: root?.settings.metaData.selectedMerchantStatus,
    isSmid: root?.user?.isSmid,
    payoutsEnabled: root.settings.metaData.isSplitSettlementsEnabled,
    supersetDashboards: root.superset.dashboards,
    hasSupersetPermission: root?.userManagement?.hasSupersetPermission,
    showChatbotAwareness: root.settings.metaData.showChatbotAwareness,
    setShowChatbotAwareness: root.settings.metaData.setShowChatbotAwareness,
    shouldEnableSettingForSuperset: root.userManagement.shouldEnableSettingForSuperset(),
  }))

  let selectedDashboardId = ''

  const notAllowedPermission: Array<String> = notAllowedUserPermission()

  const resetPagination = () => {
    const routeModelMap: any = {
      transactions: 'transactions',
      refunds: 'transactions',
      settlements: 'settlements',
      bulkrefund: 'bulkRefund',
      paymentlinks: 'links',
      subscriptions: 'subscriptions',
    }
    const model = routeModelMap[route]
    model && model.length > 0 && RootStore?.[model]?.resetPagination()
  }

  const onPress = (item: any): void => {
    if (item?.id !== 'DIVIDER') {
      if (item?.navigateTo === Routes.FAQS) {
        window.open(APIEndPoints.faqs, staticStrings.targetBlank)
      } else {
        setDownloadReportType('Transaction')
        resetPagination(item?.navigateTo)
        setSearchString('')
        setSearchResultVisibility(false)
        navigation.reset({
          index: 0,
          routes: [{ name: (item && item?.navigateTo) || Routes.RECENTS }],
        })
      }
    }
  }

  const closeTrxDetailsView = () => {
    setTransactionDetails(false)
    setTxnId('')
  }

  const initiateRefund = (id: string): void => {
    if (id) {
      updateSelectedTxn(id)
      navigateTo()
      closeTrxDetailsView()
    }
  }

  const navigateTo = () => {
    const getUrl = {
      transactions: Routes.TRX_INITIATEREFUND,
      refunds: Routes.REFUND_INITIATEREFUND,
      // settlements: Routes.SETTLEMENTS_INITIATEREFUND,
      // invoices: Routes.INVOICES_INITIATEREFUND,
      // contact: Routes.CONTACT_INITIATEREFUND,
      // home: Routes.HOME_INITIATEREFUND,
    }
    navigation.navigate(getUrl[path as keyof typeof getUrl] || Routes.HOME_INITIATEREFUND)
  }
  const renderTransactionDetails = (): React.ReactElement => {
    return (
      <TransactionDetails
        transactionId={txnId}
        visible={showTransactionDetails}
        initiateRefund={initiateRefund}
        closeTrxDetailsView={closeTrxDetailsView}
        transactionDate={trxDate}
      />
    )
  }

  const closeModal = () => {
    setTransactionDetails(false)
    setTxnId('')
  }

  const handleSearchResultClick = (show: boolean, trxnId: string = '', txnDate) => {
    setTransactionDetails(show)
    setTxnId(trxnId)
    setTrxDate(txnDate)
  }

  const path = location
  /* in Box backgroundImage is not working so kept it view for gradientBgStyle */

  const getRoute = () => {
    const paths: any = {
      'refund-reports': Routes.REFUNDS,
      'bulk-refund': Routes.BULK_REFUND,
      'payment-links': Routes.PAYMENT_LINKS,
      'refunds/initiate-refunds': Routes.REFUNDS,
      'transactions/initiate-refunds': Routes.TRANSACTIONS,
      'subscriptions/initiate-refunds': Routes.SUBSCRIPTIONS,
      'initiate-refunds': Routes.RECENTS,
      'bulkrefund/report': Routes.BULK_REFUND,
      'bulkrefund/summary': Routes.BULK_REFUND,
      'campaigns/createcampaign': Routes.CAMPAIGNS,
      payoutsbeneficiary: Routes.PAYOUTS_BENEFICIARY,
    }

    const browserPath = window?.location?.pathname?.slice(REACT_APP_ENDPOINT.length + 1)

    if (hasSupersetPermission()) {
      let DEFAULT_ROUTE =
        supersetDashboards.length > 0 || !shouldEnableSettingForSuperset ? Routes.SUPERSET_DASHBOARD : Routes.SETTINGS
      if (params?.initialRoute?.startsWith(Routes.SUPERSET_DASHBOARD) && supersetDashboards.length > 0) {
        DEFAULT_ROUTE = Routes.SUPERSET_DASHBOARD
        selectedDashboardId = params?.initialRoute?.split?.('?dashboardId=')?.[1]
      } else if (
        [Routes.SETTINGS, 'add-new-user', 'EditUserRole'].includes(params?.initialRoute) &&
        shouldEnableSettingForSuperset
      ) {
        DEFAULT_ROUTE = Routes.SETTINGS
      } else if (params?.initialRoute === 'contact-us') {
        DEFAULT_ROUTE = Routes.CONTACT
      }
      return DEFAULT_ROUTE
    } else if (params?.initialRoute) {
      return paths[params?.initialRoute] ?? params?.initialRoute
    }
    return paths[browserPath] ?? browserPath
  }
  const isLargeScreen = useIsLargeScreen()

  const isSmallDevice = isMobile(isLargeScreen)

  return (
    <>
      <ModalDialog
        children={
          <RenderChatbotAwarenessWeb
            isSmallDevice={isSmallDevice}
            onPress={() => console.log('chat')}
            onCancel={() => setShowChatbotAwareness(false)}
          />
        }
        type={'Right'}
        show={showChatbotAwareness}
        onDismiss={() => console.log('do not close')}
      />
      <ModalDialog
        children={renderTransactionDetails()}
        show={showTransactionDetails}
        type={'Right'}
        onDismiss={closeModal}
      />
      {/* <InActivity /> */}
      <Box {...styles.container}>
        <LinearGradientContainer
          customStyle={styles.gradientBgStyle(width) as ViewStyle}
          colorArray={[Colors.DARK_BLUE, '#0186B0']}
          direction="HORIZONTAL">
          <NavBarNew
            onPress={onPress as any}
            notAllowedPermissions={notAllowedPermission}
            permissionLoader={permissionLoader}
            isSuperMerchant={isSmid}
            showPayouts={payoutsEnabled}
            supersetDashboards={supersetDashboards}
            hasSupersetPermission={hasSupersetPermission()}
            shouldEnableSettingForSuperset={shouldEnableSettingForSuperset}
          />
        </LinearGradientContainer>
        <Box {...styles.childContainer}>
          <ModBox {...styles.containerInner}>
            <Suspense fallback={<SuspenseLoading />}>
              <Stack.Navigator
                id={undefined}
                initialRouteName={getRoute() || Routes.RECENTS}
                screenOptions={{
                  header: () => (
                    <Header
                      hide={!showSearchView(path)}
                      path={path}
                      onSearchResultClicked={handleSearchResultClick}
                      isSuperMerchant={isSmid}
                    />
                  ),
                }}>
                <Stack.Screen
                  name={Routes.RECENTS}
                  component={Dashboard}
                  options={{
                    title: staticStrings.dashboard,
                  }}
                />
                <Stack.Screen
                  name={`${Routes.PROFILE}`}
                  component={Profile}
                  options={{
                    title: 'Profile',
                  }}
                />
                <Stack.Screen
                  name={Routes.CONTACT}
                  component={ContactUs}
                  options={{
                    title: staticStrings.contact,
                  }}
                />
                {canViewTransactionDetails && (
                  <Stack.Screen
                    name={`${Routes.TRANSACTIONS}/:transactionId`}
                    component={TransactionDetails}
                    options={{
                      title: staticStrings.transactionsDetails,
                    }}
                  />
                )}
                <Stack.Screen name={`${Routes.SETTLEMENTS}/:transactionId`} component={TransactionDetails} />
                <Stack.Screen name={`${Routes.REFUNDS}/:transactionId`} component={TransactionDetails} />
                {/* <Stack.Screen name={`${Routes.DISPUTES}/:transactionId`} component={TransactionDetails} /> */}
                <Stack.Screen name={`${Routes.HOME}/:transactionId`} component={TransactionDetails} />
                <Stack.Screen name={`${Routes.DEFAULT}/:transactionId`} component={TransactionDetails} />
                {!notAllowedPermission?.includes('Transactions') && (
                  <Stack.Screen
                    name={'transactions'}
                    component={Transactions}
                    options={{
                      title: 'Transactions',
                    }}
                  />
                )}
                <Stack.Screen
                  name={`${Routes.SETTLEMENTS}`}
                  component={SettlementsScreen}
                  options={{
                    title: 'Settlements',
                  }}
                />
                {!notAllowedPermission?.includes('Refunds') && (
                  <Stack.Screen
                    name={`${Routes.REFUNDS}`}
                    component={RefundsNew}
                    options={{
                      title: 'Refunds',
                    }}
                  />
                )}
                <Stack.Screen
                  name={`${Routes.SUPERSET_DASHBOARD}`}
                  component={SupersetEmbedded}
                  initialParams={
                    {
                      dashboardId: selectedDashboardId || supersetDashboards?.[0]?.dashboardId,
                    } as any
                  }
                />
                {/* <Stack.Screen name={`${Routes.DISPUTES}`} component={Transactions} /> */}
                <Stack.Screen
                  name={`${Routes.TRX_INITIATEREFUND}`}
                  component={InitiateRefund}
                  options={{
                    title: 'Initiate Transaction Refunds',
                  }}
                />
                <Stack.Screen
                  name={`${Routes.REFUND_INITIATEREFUND}`}
                  component={InitiateRefund}
                  options={{
                    title: 'Initiate Refunds',
                  }}
                />
                <Stack.Screen
                  name={`${Routes.SUBSCRIPTION_INITIATEREFUND}`}
                  component={InitiateRefund}
                  options={{
                    title: 'Initiate Settlement Refunds',
                  }}
                />
                {canCreatePaymentLink && (
                  <Stack.Screen
                    name={Routes.CREATE_PAYMENT_LINK}
                    component={CreatePaymentLink}
                    options={{
                      title: 'Create Payment Link',
                    }}
                  />
                )}
                {!notAllowedPermission?.includes('Insights') && (
                  <Stack.Screen
                    name={`${Routes.INSIGHTS}`}
                    component={Insights}
                    options={{
                      title: 'Insights',
                    }}
                  />
                )}
                <Stack.Screen name={`${Routes.HOME_INITIATEREFUND}`} component={InitiateRefund} />
                <Stack.Screen name={`${Routes.CAMPAIGNS}`} component={Campaigns} />
                <Stack.Screen
                  name={Routes.CREATE_CAMPAIGN}
                  component={CreateCampaign}
                  options={{
                    title: 'Create Campaign',
                  }}
                />
                <Stack.Screen
                  name={Routes.CAMPAIGN_DETAILS}
                  component={CampaignDetails}
                  options={{
                    title: 'Campaign Details',
                  }}
                />

                {/* {profileScreens()} */}
                {!notAllowedPermission?.includes('Payment Links') && (
                  <Stack.Screen
                    name={`${Routes.PAYMENT_LINKS}`}
                    component={PaymentLinks}
                    options={{
                      title: staticStrings.paymentLinks,
                    }}
                  />
                )}
                {!notAllowedPermission?.includes('Settings') && (
                  <Stack.Screen
                    name={Routes.SETTINGS}
                    options={{
                      title: 'Settings',
                    }}
                    component={Settings}
                  />
                )}
                {!notAllowedPermission?.includes('Bulk Refund') && (
                  <Stack.Screen
                    name={`${Routes.BULK_REFUND}`}
                    component={BulkRefund}
                    options={{
                      title: 'Bulk Refund',
                    }}
                  />
                )}
                <Stack.Screen
                  name={`${Routes.VAULT}`}
                  component={Vault}
                  options={{
                    title: 'Vault',
                  }}
                />
                {!notAllowedPermission?.includes('Subscriptions') && (
                  <Stack.Screen
                    name={`${Routes.SUBSCRIPTIONS}`}
                    options={{
                      title: 'Subscriptions',
                    }}
                    component={Subscriptions}
                  />
                )}
                {!notAllowedPermission?.includes('UPI QR code') && (
                  <Stack.Screen
                    name={Routes.UPIQRCODE}
                    options={{
                      title: 'UPI QR Code',
                    }}
                    component={UpiQRCode}
                  />
                )}
                <Stack.Screen
                  name={Routes.DOWNLOADS}
                  options={{
                    title: 'Downloads',
                  }}
                  component={Downloads}
                />
                <Stack.Screen
                  name={Routes.DOWNLOADS_TXNS}
                  options={{
                    title: 'Downloads',
                  }}
                  component={Downloads}
                />
                <Stack.Screen
                  name={Routes.DOWNLOADS_SETTLEMENTS}
                  options={{
                    title: 'Downloads',
                  }}
                  component={Downloads}
                />
                <Stack.Screen
                  name={Routes.DOWNLOADS_REFUNDS}
                  options={{
                    title: 'Downloads',
                  }}
                  component={Downloads}
                />
                <Stack.Screen name={Routes.USER_MANAGEMENT.ADD_NEW_USER} component={AddNewUser} />
                <Stack.Screen name={Routes.USER_MANAGEMENT.EDIT_USER_ROLE} component={EditUserRole} />
                <Stack.Screen
                  name={`${Routes.SETTLEMENTS_REPORTING}`}
                  component={SettlementsReporting}
                  options={{
                    title: 'Settlements Reporting',
                  }}
                />
                <Stack.Screen
                  name={Routes.REPORT_CONFIGURATION}
                  options={{
                    title: 'Report Configuration',
                  }}
                  component={NotAvailableConfiguration}
                />
                <Stack.Screen
                  name={Routes.SETTLEMENTS_ADD_UPDATE_REPORT}
                  component={AddNewSettlementReport}
                  options={{
                    title: 'Add New Settlements Report',
                  }}
                />
                {payoutsEnabled && (
                  <Stack.Screen
                    name={`${Routes.PAYOUTS}`}
                    component={Payouts}
                    options={{
                      title: 'Payouts',
                    }}
                  />
                )}
                {payoutsEnabled && (
                  <Stack.Screen
                    name={`${Routes.PAYOUTS_HISTORY}`}
                    component={PayoutHistory}
                    options={{
                      title: 'Payouts History',
                    }}
                  />
                )}
                {payoutsEnabled && (
                  <Stack.Screen
                    name={`${Routes.PAYOUTS_BENEFICIARY}`}
                    component={BeneficiaryOnboarding}
                    options={{
                      title: 'Payouts Beneficiary',
                    }}
                  />
                )}
                {payoutsEnabled && (
                  <Stack.Screen
                    name={`${Routes.PAYOUTS_LINK}`}
                    component={PayoutsLink}
                    options={{
                      title: 'Payouts Link',
                    }}
                  />
                )}
                <Stack.Screen
                  name={Routes.HELP_AND_SUPPORT}
                  component={HelpAndSupportMobileWeb}
                  options={{
                    title: 'Add New Settlements Report',
                  }}
                />
              </Stack.Navigator>
            </Suspense>
          </ModBox>
          <Footer />
        </Box>
      </Box>
    </>
  )
}

export default NewDashboard

const SuspenseLoading = () => {
  return (
    <Box width={'100%'} height="100%" justifyContent={'center'}>
      <LoaderNew color={'BLUE'} />
    </Box>
  )
}
